import { useQuery, useMutation } from '@apollo/client';

import { getReviewPage } from '../queries/reviewPage.graphql';
import { feedbackQuestion } from '../queries/qna.graphql';

export const useQandAPage = ({ path, productId, dispatchMetrics }) =>
  useQuery(getReviewPage, {
    variables: { path, productId },
    onCompleted: /* istanbul ignore next */ data => {
      dispatchMetrics('page:load', data);
    },
  });

export const LikeAnswer = () => {
  const [likeAnswerAction] = useMutation(feedbackQuestion);
  return likeAnswerAction;
};

export const DislikeAnswer = () => {
  const [dislikeAnswerAction] = useMutation(feedbackQuestion);
  return dislikeAnswerAction;
};
